// @flow
import {
  DIFFERENT_ACCOUNT_OWNER,
  DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER,
  DIRECT_DEBIT_IBAN,
  IMPORT_FROM_DELIVERY_ADDRESS,
} from "./Constants";
import { normalizeOptions } from "../../utils";
import type { OptionT } from "../../misc/Types";
import i18n from "../../../../../i18n";

function getLabel(property: string, option: string) {
  return i18n.t(`common:payment.${property}.options.${option}`);
}

const normalize = normalizeOptions(getLabel);

export const PaymentMethodOptions = {
  [DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER]: DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER,
  [DIRECT_DEBIT_IBAN]: DIRECT_DEBIT_IBAN,
};

export type PaymentMethodOptionT = typeof DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER | typeof DIRECT_DEBIT_IBAN;

const defaultPaymentMethodOptions = [DIRECT_DEBIT_IBAN, DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER];

type PaymentFormOptionsType = {
  accountOwnerType: OptionT[],
  paymentMethod: OptionT[],
};

export const PaymentFormOptions = (normalize({
  accountOwnerType: [IMPORT_FROM_DELIVERY_ADDRESS, DIFFERENT_ACCOUNT_OWNER],
  paymentMethod: defaultPaymentMethodOptions,
}): PaymentFormOptionsType);

export default PaymentFormOptions;
